import { FC } from "react";

import { Popover, Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

import PopoverHeader from "../popover/PopoverHeader";
import { PopoverHorizontalPlacement } from "../popover/PopoverModels";
import { popoverStyle } from "../popover/SgPopoverStyle";
import { TextEnum } from "../TextStyles";

interface IPopperProps {
  children: React.ReactElement;
  title?: string;
  titleBorder?: boolean;
  titleTextSize?: TextEnum;
  transformHorizontalPlacement?: PopoverHorizontalPlacement;
  anchorHorizontalPlacement?: PopoverHorizontalPlacement;
  isOpen: boolean;
  handleClose: () => void;
  anchorEl?: HTMLElement | null;
  displayHeader?: boolean;
  centered?: boolean;
  showBackdrop?: boolean;
  sx?: SystemStyleObject<Theme>;
}

const Dialog: FC<IPopperProps> = ({
  children,
  title,
  titleTextSize,
  titleBorder = true,
  isOpen,
  handleClose,
  anchorEl,
  transformHorizontalPlacement = "center",
  anchorHorizontalPlacement = "right",
  displayHeader = true,
  centered = false,
  showBackdrop = false,
  sx,
}) => {
  const id = isOpen ? "simple-popover" : undefined;
  return (
    <Popover
      id={id}
      open={isOpen}
      onClose={handleClose}
      {...(centered
        ? {
            anchorReference: "none",
            transformOrigin: {
              vertical: "center",
              horizontal: "center",
            },
          }
        : {
            anchorEl,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: anchorHorizontalPlacement,
            },
            transformOrigin: {
              vertical: "top",
              horizontal: transformHorizontalPlacement,
            },
          })}
      sx={{
        ...popoverStyle,
        "& .MuiPopover-paper > div": {
          overflowY: "auto",
          maxHeight: "60vh",
          padding: "20px",
        },
        ...sx,
        ...(centered && {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&& .MuiPopover-paper": {
            position: "relative",
            marginTop: 0,
          },
        }),
      }}
      slotProps={{
        ...(showBackdrop && {
          root: {
            slotProps: {
              backdrop: {
                invisible: false,
                sx: { backgroundColor: "rgba(0, 0, 0, 0.2)" },
              },
            },
          },
        }),
      }}
    >
      {displayHeader && (
        <PopoverHeader title={title} borderBottom={titleBorder} textSize={titleTextSize} />
      )}
      <div>{children}</div>
    </Popover>
  );
};

export default Dialog;
